import { render, staticRenderFns } from "./add_dialog.vue?vue&type=template&id=b8ec7f94&"
import script from "./add_dialog.vue?vue&type=script&lang=js&"
export * from "./add_dialog.vue?vue&type=script&lang=js&"
import style0 from "./add_dialog.vue?vue&type=style&index=0&id=b8ec7f94&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports